<template>
  <div>
    <v-card >
      <v-card-title>
        <v-text-field v-if="items.length > 10"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-model="selected_items"
        v-model:page="page"
        v-model:items-per-page="itemsPerPage"
        item-value="id"
        :sort-by="sortBy"
        :show-select="show_select"
        :search="search"
        :items="items"
        :headers="table_headers">
        <template v-slot:top>
          <v-dialog v-model="dialog_delete" max-width="500px">
            <v-card>
              <v-card-title>Are you sure you want to delete this {{item_name}}?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close_dialog_delete">Cancel</v-btn>
                <v-btn color="primary" text @click="delete_item_for_real">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-for="property in template_slots" v-slot:[`item.${property}`]="{ item }">
          <slot :name="property" v-bind:item="item"></slot>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn v-if="show_edit_action" icon @click="edit_item(item)" color="primary" x-small>
            <v-icon>fas fa-pencil-alt</v-icon>
          </v-btn>
          <v-btn v-if="show_delete_action" icon @click="delete_item(item)" color="primary" x-small>
            <v-icon>far fa-trash-alt</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    </div>
</template>

<script>
import { vuetifyHeaders } from '@/utils/vuetifyHeaders';

export default {
  name: "DataTable",
  data() {
    return {
      'selected_items': [],
      'search': '',
      page: 1,
      itemsPerPage: 50,
      'dialog': false,
      'editedIndex': 0,
      'editedItem': false,
      'dialog_delete': false,
      /** When true, selection was set from props — do not emit (would clear parent e.g. task users). */
      _selectionSyncFromProps: false,
    }
  },
  watch: {
    selected_items(n) {
      if (this._selectionSyncFromProps) {
        return;
      }
      const raw = n || [];
      const ids = raw.map((i) => (i != null && typeof i === 'object' ? i.id : i));
      this.$emit(
        'select_item_id',
        ids.filter((id) => id != null && Number.isFinite(Number(id))),
      );
    },
    selected_item_ids: {
      handler() {
        this.syncSelectionFromProps();
      },
      deep: true,
    },
    items: {
      handler() {
        this.syncSelectionFromProps();
      },
      deep: true,
    },
    items_per_page(value) {
      this.itemsPerPage = value;
    },
  },
  props: {
    template_slots: {default: () => []},
    selected_item_ids: {default: () => []},
    items_per_page: {default: 50},
    show_select: {default: false},
    items: {required: true},
    headers: {required: true},
    show_header: {default: true},
    parent: {default: false},
    item_name: {default: 'item'},
    show_delete_action: {default: true},
    show_edit_action: {default: true},
    single_expand: {default: false},
    /** Vuetify sort-by keys; default name, override when items use another field (e.g. email). */
    sort_by: {default: () => [{ key: 'name', order: 'asc' }]},
  },

  computed: {
    item_ids() {
      return this.items.map(l=>{return l.id})
    },
    sortBy() {
      const s = this.sort_by;
      if (Array.isArray(s) && s.length > 0) {
        return s;
      }
      return [{ key: 'name', order: 'asc' }];
    },
    table_headers() {
      const headers = [...this.headers];
      if (this.show_delete_action || this.show_edit_action) {
        headers.push({ text: 'Actions', value: 'actions', sortable: false });
      }
      return vuetifyHeaders(headers);
    },
  },
  methods: {
    delete_item(item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_delete = true
    },
    async delete_item_for_real() {
      await this.$api.model.delete(this.editedItem.id);
      this.$emit('delete_item', this.editedItem.id);
      this.close_dialog_delete();
    },
    close_dialog_delete() {
      this.dialog_delete = false
    },
    close_modal() {
      this.dialog = false
    },
    edit_item (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
    },
    update_item(item) {
      this.$emit('update_item', item)
    },
    refresh () {
      this.$emit('refresh')
    },
    syncSelectionFromProps() {
      if (!this.show_select) {
        return;
      }
      const idKey = (id) => String(id);
      const ids = new Set((this.selected_item_ids || []).map(idKey));
      // Vuetify 3 v-data-table selection v-model is an array of item-value keys (ids), not row objects.
      const nextIds = (this.items || [])
        .filter((item) => ids.has(idKey(item.id)))
        .map((item) => item.id);
      const curIds = (this.selected_items || []).map((i) =>
        i != null && typeof i === 'object' ? i.id : i,
      );
      const curKeySet = new Set(curIds.map(idKey));
      const nextKeySet = new Set(nextIds.map(idKey));
      const same =
        curKeySet.size === nextKeySet.size &&
        [...nextKeySet].every((k) => curKeySet.has(k));
      if (same) {
        return;
      }
      this._selectionSyncFromProps = true;
      this.selected_items = [...nextIds];
      this.$nextTick(() => {
        this._selectionSyncFromProps = false;
      });
    },
  },
  mounted() {
    this.itemsPerPage = this.items_per_page;
    this.syncSelectionFromProps();
  }
}
</script>

<style scoped>

</style>